<template>
  <div class="mt-4">
    <div v-if="title" class="text-uppercase font-weight-medium grey--text text-left mb-2">{{ title }}</div>
    <v-layout row wrap>
      <v-flex v-for="item in items" :key="item.id">
        <u-deploy-choice
          :selected="selected === item"
          :item="item"
          @toggle="$emit('toggle', item)"
        ></u-deploy-choice>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DeployChoiceComponent from '@/components/deploy/Choice.vue'

export default {
  props: {
    /**
     * An optional title for the selection.
     */
    title: String,
    /**
     * The list of choices to display.
     */
    items: Array,
    /**
     * The currently selected item.
     */
    selected: Object
  },
  components: {
    'u-deploy-choice': DeployChoiceComponent
  }
}
</script>
